import { gql } from '@apollo/client'

const LESSON_PACK_FIELDS = `
  id
  totalCredits
  remainingCredits
  expiresAt
  lessonCredits {
    updatedAt
    enrollment {
      lesson {
        startDateTime
      }
      student {
        firstName
        lastName
      }
    }
  }
  lessonType {
    id
    title
    category
    durationInMinutes
    locations {
      id
      name
    }
    coach {
      name
      bookingUrl
      externalId
      coachProfile {
        slug
      }
    }
    giftingEnabled
    deletedAt
    status
  }
`

const GIFTED_LESSON_CREDIT_BALANCE_FIELDS = `
  totalCredits
  remainingCredits
  nextExpirationDate
  lessonType {
    id
    title
    category
    durationInMinutes
    locations {
      id
      name
    }
    coach {
      name
      bookingUrl
      externalId
      coachProfile {
        slug
      }
    }
    deletedAt
    status
  }
`

const GET_LESSON_CREDIT_BALANCE = gql`
  query lessonCreditBalances {
    currentUser {
      attributes {
        ... on Contact {
          lessonPacks {
            ${LESSON_PACK_FIELDS}
          }
          giftedLessonCreditBalances {
            ${GIFTED_LESSON_CREDIT_BALANCE_FIELDS}
          }
        }
      }
    }
  }
`

export default GET_LESSON_CREDIT_BALANCE
